export function getApiEndpoint() {
    return env.SUBTRACE_API_ENDPOINT;
}
